// one-time migration to the project management model: full backup first (own IndexedDB), rollback by button
import { dbPut } from './db';
import { ensurePm, PM_SCHEMA } from './pm';

const BK = 'GissPmBackup', FLAG = 'giss_pm_migrated', OFF = 'giss_pm_rolledback';
const open = () => new Promise((res, rej) => { const r = indexedDB.open(BK, 1); r.onupgradeneeded = () => r.result.createObjectStore('b'); r.onsuccess = () => res(r.result); r.onerror = rej; });
const tx = async (mode, fn) => { const d = await open(); return new Promise((res, rej) => { const t = d.transaction('b', mode), q = fn(t.objectStore('b')); t.oncomplete = () => res(q?.result); t.onerror = () => rej(t.error); }); };
export const backupInfo = () => tx('readonly', (s) => s.get('meta')).catch(() => null);
export const migrated = () => !!localStorage.getItem(FLAG);
export const rolledBack = () => !!localStorage.getItem(OFF);

export async function pmMigrate(all) {
  if (rolledBack()) return all;
  const todo = all.filter((p) => p.pm?.schema !== PM_SCHEMA);
  if (todo.length && !(await backupInfo())) {
    await tx('readwrite', (s) => { s.put(structuredClone(all.map((p) => ({ ...p }))), 'projects'); return s.put({ at: Date.now(), n: all.length, schema: PM_SCHEMA }, 'meta'); });
  }
  for (const p of todo) { ensurePm(p); await dbPut(p).catch(() => {}); }
  if (todo.length) localStorage.setItem(FLAG, String(Date.now()));
  return all;
}
// back to the state before the update: originals are written back, new projects stay untouched
export async function pmRollback() {
  const list = await tx('readonly', (s) => s.get('projects'));
  if (!list) return 0;
  for (const p of list) await dbPut(p);
  localStorage.setItem(OFF, String(Date.now()));
  return list.length;
}
export const pmReenable = () => localStorage.removeItem(OFF);
